import { render, staticRenderFns } from "./CustomerCardDefaultShipmentType.vue?vue&type=template&id=4a87ea18&scoped=true"
import script from "./CustomerCardDefaultShipmentType.vue?vue&type=script&lang=ts"
export * from "./CustomerCardDefaultShipmentType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87ea18",
  null
  
)

export default component.exports